import type { FC } from 'react'

import { Button } from '@skytech/ui/Button'
import { useQuery } from '@tanstack/react-query'
import BackIcon from 'mdi-react/ArrowLeftIcon'
import { useNavigate } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'

import queries from '@/api/queries'
import { usePolicyId } from '@/components/ecom-policy/hooks/use-policy-id'
import { Translation } from '@/components/i18n/Translation'
import { useCart } from '@/contexts/cart/cart-context'
import { useIsThreeStepIT } from '@/hooks/user'
import { ecomPolicyResources } from '@/resources/ecom-policy'
import { APP_ROUTES } from '@/util/appRoutes'

import { usePolicyContext } from './Policy.context'

export const GreenpoolInfo: FC = () => {
  const navigate = useNavigate()
  const isThreeStepIT = useIsThreeStepIT()
  const policyId = usePolicyId()
  const policyCtx = usePolicyContext()
  const [, setActiveStep] = policyCtx.activeStep
  const { hasGreenpoolItem, hasNonGreenpoolItem } = useCart()

  const { data } = useQuery(queries.policy(policyId), () => ecomPolicyResources.get(policyId))

  return (
    <div className="greenpool-info m-auto w-full max-w-5xl sm:w-11/12 md:w-10/12">
      <p className="!mx-0 !my-4 whitespace-pre-line">
        {data?.greenpoolSplashText || <Translation id="Some default text for the splash message" />}
      </p>

      <footer className="flex flex-col items-center justify-center gap-4">
        <div className="mt-4 flex w-full flex-col items-center justify-center sm:flex-row">
          <Button
            variant={isThreeStepIT ? 'primary' : 'secondary'}
            disabled={hasNonGreenpoolItem(policyId)}
            className={twMerge(
              'w-full text-wrap',
              !isThreeStepIT &&
                'selected:bg-green-700 bg-green-500 text-white hover:bg-green-600 focus:bg-green-700 focus:text-white active:bg-green-700 active:text-white'
            )}
            onClick={() => setActiveStep('GREENPOOL_PRODUCT_SELECT')}
          >
            <Translation id="Show me these almost new assets" />
          </Button>

          <Button
            className="w-full text-wrap"
            disabled={hasGreenpoolItem(policyId)}
            variant={isThreeStepIT ? 'secondary' : 'primary'}
            onClick={() => setActiveStep('PRODUCT_SELECT')}
          >
            <Translation id="Go to the products" />
          </Button>
        </div>

        <Button
          variant="tertiary"
          onClick={() => navigate(APP_ROUTES.ecomPolicyList)}
          Icon={<BackIcon />}
        >
          <Translation id="Back to the policy list" />
        </Button>
      </footer>
    </div>
  )
}
